/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable import/no-unresolved */
/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
/* eslint-disable max-len */

import React, { useState, useEffect } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Card,
  Divider,
} from '@material-ui/core';
import { MdAccessTime, MdPanoramaFishEye, MdCheckCircle } from 'react-icons/md';
import { IoMdPersonAdd, IoIosWarning } from 'react-icons/io';
import { HiOutlinePlusSm, HiMinusSm } from 'react-icons/hi';
import { FaUserMinus } from 'react-icons/fa';
import NavCommon from '../../components/navCommon';
import SelectCustom from '../../components/selectCustom';
import Input from '../../components/input';
import Colors from '../../constants/color';
import {
  Form,
  Cards,
  ColumnForm,
  RowForm,
  Footer,
  FooterTurnContainerRight,
  RowInput,
  ContainerTurn,
  DaysContainer,
  RowSelect,
  FooterTurn,
  ContainerRow,
  PeriodoContainer,
  Padding,
  style,
  ContainerTurnColum,
  ContainerTurnRow,
  PDV,
  ContainerBtn,
  RowBtn,
  ContainerForm,
  ContainerColumnUsers,
  ContainerRownHeader,
  SubContainerHedaer,
  Small,
  ContainerColumnList,
  SizedBox,
  SmallForm,
  PlaceName,
  ContainerImageVoid,
  Rounded,
  TextFile,
  SubTextFile,
  ContainerImageBase,
  DescriptionPhoto,
  SmallPorcent,
  ImageIcon,
  ImageIconSucess,
  LeftContainer,
  LeftContainerFooter,
  Space,
  ScrowView,
  ContainerExt,
} from './styles';
import { requestCategory } from '../../store/ducks/category/actions';
import { CategoryStateReducer, CategoryState } from '../../store/ducks/category/types';
import { requestLocalClassifictations } from '../../store/ducks/localClassification/actions';
import { LocalclassificationState, LocalclassificationStateReducer } from '../../store/ducks/localClassification/types';
import {
  createLocalAction,
  requestGetLocalById,
  setCleanLocalScreen,
  updateLocalAction,
} from '../../store/ducks/locais/actions';
import { DaysOfWeek } from '../../utils/dayOfWeek';
import { CodePerShift } from '../../utils/codePerShift';
import TimePickerComponent from '../../components/timePicker';
import { LocaisStateReducer } from '../../store/ducks/locais/types';
import { CreateFunction } from '../../utils/createStruct';
import SelectInput from '../../components/selectInput';
import {
  positions, quantityPersonToTurn,
} from '../../utils/positions';
import Container from '../../components/container';
import {
  DayOffWeek, Turn, UserPlatform,
} from '../../interfaces';
import axiosUsers from '../../services/axiosServicesUsers';
import GoBack from '../../components/goBack';
import MyLoader from '../../components/placeholderCommon';
import DayRounded from '../../components/daysRounded';
import ButtonWithIcon from '../../components/buttonWithIcon';
import ButtonIconRounde from '../../components/buttonIconRounded';
import ItemUser from '../../components/itemUser';
import UnderlineButton from '../../components/baseButton';
import UploadFile from '../../assets/upload_file.png';
import CheckSucess from '../../assets/check.png';
import GlobalModal from '../../components/globalModal';
import CheckBox from '../../components/checkbox';
import SearchBar from '../../components/searchBar';
import IOSSwitch from '../../components/IOsSwitch';

// @ts-ignore
const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor: '#333333',
    width: '100%',
    flex: 1,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    fontSize: 14,
  },
}));

interface Params {
  idLocal: string;
  edit: boolean;
  usersProps: Array<any>
  isPDV: boolean;
  localName: string;
}

const Places = () => {
  const statesParams = useLocation<Params>()?.state;
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    loadingLocalData, loading, localData, clear,
  } = useSelector<RootStateOrAny, LocaisStateReducer>((state) => state.locais);
  const { data: dataCategoria } = useSelector<RootStateOrAny, CategoryStateReducer>((state) => state.category);
  const { data: dataClassifications } = useSelector<RootStateOrAny, LocalclassificationStateReducer>((state) => state.localClassification);

  const [search, setSearch] = useState<string>('');
  const [name, setName] = useState<string | null>();
  const [addres, setAddres] = useState<string | null>();
  const [number, setNumber] = useState<string | null>();
  const [complement, setComplement] = useState<string | null>();
  const [bairro, setBairro] = useState<string | null>();
  const [imgBase64, setImgBase64] = useState<string>('');
  const [imgBase64Name, setImgBase64Name] = useState<string>('');
  const [categorySelectedObj, setCategorySelectedObj] = useState<CategoryState | null>(null);
  const [classificationSelectedObj, setClassificationSelectedObj] = useState<LocalclassificationState | null>(null);
  const [dobraPosicao, setDobraPosicao] = useState<boolean>();
  const [LimiteAgendamentosTurnos, setLimiteAgendamentos] = useState<number>(0);
  const [users, setUsers] = useState<Array<UserPlatform>>();
  const [open, setOpen] = useState<boolean>(false);
  const classes = useStyles();
  const [openLocal, setOpenLocal] = useState<boolean>(false);
  const [daysOfWeek, setDaysOfWeek] = useState<Array<any>>([]);
  const [turnos, turnosSelecionados] = useState<Array<any>>([]);
  const [sizeList] = useState<number>(10);
  const [daysOfTurn, setDyasOfTurn] = useState<Array<string>>([]);
  const [imgErro, setImgError] = useState<boolean>(false);
  const [timeSee, setTimeSee] = useState<boolean>(false);
  const [filterActive, setFilterActive] = useState('');
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    setDaysOfWeek(DaysOfWeek);
    turnosSelecionados(CodePerShift);
  }, []);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    turnsOfWeek(daysOfWeek);
  }, [daysOfWeek]);

  useEffect(() => {
    if (statesParams?.edit) {
      dispatch(requestGetLocalById(statesParams?.idLocal));
    } else {
      Clean();
    }
  }, [statesParams]);

  useEffect(() => {
    if (localData !== null) {
      modeEdit();
    }
  }, [localData, loadingLocalData]);

  useEffect(() => {
    if (clear) {
      Clean();
    }
  }, [clear]);

  useEffect(() => {
    resetLocalState();
  }, []);

  // useEffect(() => {
  //   getUsers();
  // }, []);

  useEffect(() => {
    getUsers(filterActive);
    setSelectAll(false);
  }, [filterActive]);

  const getUsers = async (filterActive?: string) => {
    try {
      const response = await axiosUsers.get(`admin/usuarios/v1/usuarios-gestao-locais?usuariosAtivo=${filterActive}`);
      const { data: dataUSers } = response.data;

      if (statesParams.edit === true) {
        if (statesParams.usersProps !== undefined) {
          setUsers(
            dataUSers?.map((item: any) => {
              statesParams?.usersProps.map((it) => {
                if (it.idUsuario === item.id) {
                  item.check = true;
                  return item;
                }
                return item;
              });
              return item;
            }),
          );
        }
      } else {
        setUsers(dataUSers);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetLocalState = () => {
    DaysOfWeek.map((item) => {
      item.hours = [];
      item.check = false;
      return item;
    });
    CodePerShift.map((item) => {
      item.check = false;
      item.limiteAgendamentosTurnoPorUsuario = null;
      return item;
    });
  };

  function Clean() {
    setName('');
    setBairro('');
    setAddres('');
    setNumber('');
    setComplement('');
    setCategorySelectedObj(null);
    setClassificationSelectedObj(null);
    setImgBase64('');
    setImgBase64Name('');
    setDobraPosicao(false);
    unCheck();

    DaysOfWeek.map((item) => {
      item.check = false;
      return item;
    });

    CodePerShift.map((item) => {
      item.check = false;
      item.limiteAgendamentosTurnoPorUsuario = null;
      return item;
    });
    dispatch(setCleanLocalScreen(false));
  }

  const prepareDatas = (turnos: Array<any>, manha: number | null, tarde: number | null, noite: number | null) => {
    DaysOfWeek.map((item) => {
      item.check = true;
      return item;
    });

    CodePerShift.map((item) => {
      item.check = true;
      return item;
    });

    CodePerShift[0].limiteAgendamentosTurnoPorUsuario = manha;

    CodePerShift[1].limiteAgendamentosTurnoPorUsuario = tarde;

    CodePerShift[2].limiteAgendamentosTurnoPorUsuario = noite;
    turnos?.map((item) => {
      if (item?.diaSemana?.codigo === 0) {
        DaysOfWeek[6].hours.push({
          // @ts-ignore
          init: `Fri Aug 06 2021 ${item.horaInicio} GMT-0300 (Horário Padrão de Brasília)`,
          end: `Fri Aug 06 2021 ${item.horaFim} GMT-0300 (Horário Padrão de Brasília)`,
          id: 0,
          idTurno: item.codigoTipoTurno,
          quantidadePosicoes: item.quantidadePosicoes,
          limiteAgendamentosTurnoPorUsuario: item.limiteAgendamentosTurnoPorUsuario,
        });
      }
      if (item?.diaSemana?.codigo === 1) {
        DaysOfWeek[0].hours.push({
          // @ts-ignore
          init: `Fri Aug 06 2021 ${item.horaInicio} GMT-0300 (Horário Padrão de Brasília)`,
          end: `Fri Aug 06 2021 ${item.horaFim} GMT-0300 (Horário Padrão de Brasília)`,
          id: 1,
          idTurno: item.codigoTipoTurno,
          quantidadePosicoes: item.quantidadePosicoes,
          limiteAgendamentosTurnoPorUsuario: item.limiteAgendamentosTurnoPorUsuario,
        });
      }
      if (item?.diaSemana?.codigo === 2) {
        DaysOfWeek[1].hours.push({
          // @ts-ignore
          init: `Fri Aug 06 2021 ${item.horaInicio} GMT-0300 (Horário Padrão de Brasília)`,
          end: `Fri Aug 06 2021 ${item.horaFim} GMT-0300 (Horário Padrão de Brasília)`,
          id: 2,
          idTurno: item.codigoTipoTurno,
          quantidadePosicoes: item.quantidadePosicoes,
          limiteAgendamentosTurnoPorUsuario: item.limiteAgendamentosTurnoPorUsuario,
        });
      }
      if (item?.diaSemana?.codigo === 3) {
        DaysOfWeek[2].hours.push({
          // @ts-ignore
          init: `Fri Aug 06 2021 ${item.horaInicio} GMT-0300 (Horário Padrão de Brasília)`,
          end: `Fri Aug 06 2021 ${item.horaFim} GMT-0300 (Horário Padrão de Brasília)`,
          id: 3,
          idTurno: item.codigoTipoTurno,
          quantidadePosicoes: item.quantidadePosicoes,
          limiteAgendamentosTurnoPorUsuario: item.limiteAgendamentosTurnoPorUsuario,
        });
      }
      if (item?.diaSemana?.codigo === 4) {
        DaysOfWeek[3].hours.push({
          // @ts-ignore
          init: `Fri Aug 06 2021 ${item.horaInicio} GMT-0300 (Horário Padrão de Brasília)`,
          end: `Fri Aug 06 2021 ${item.horaFim} GMT-0300 (Horário Padrão de Brasília)`,
          id: 4,
          idTurno: item.codigoTipoTurno,
          quantidadePosicoes: item.quantidadePosicoes,
          limiteAgendamentosTurnoPorUsuario: item.limiteAgendamentosTurnoPorUsuario,
        });
      }
      if (item?.diaSemana?.codigo === 5) {
        DaysOfWeek[4].hours.push({
          // @ts-ignore
          init: `Fri Aug 06 2021 ${item.horaInicio} GMT-0300 (Horário Padrão de Brasília)`,
          end: `Fri Aug 06 2021 ${item.horaFim} GMT-0300 (Horário Padrão de Brasília)`,
          id: 5,
          idTurno: item.codigoTipoTurno,
          quantidadePosicoes: item.quantidadePosicoes,
          limiteAgendamentosTurnoPorUsuario: item.limiteAgendamentosTurnoPorUsuario,
        });
      }
      if (item?.diaSemana?.codigo === 6) {
        DaysOfWeek[5].hours.push({
          // @ts-ignore
          init: `Fri Aug 06 2021 ${item.horaInicio} GMT-0300 (Horário Padrão de Brasília)`,
          end: `Fri Aug 06 2021 ${item.horaFim} GMT-0300 (Horário Padrão de Brasília)`,
          id: 6,
          idTurno: item.codigoTipoTurno,
          quantidadePosicoes: item.quantidadePosicoes,
          limiteAgendamentosTurnoPorUsuario: item.limiteAgendamentosTurnoPorUsuario,
        });
      }
    });
    turnsOfWeek(DaysOfWeek);
  };

  const turnsOfWeek = (Days: Array<DayOffWeek>) => {
    Days.map((item) => {
      if (item.idDiaDaSemana === 1 && item.hours.length > 0) {
        setDyasOfTurn((state) => [...state, 'Segunda']);
      }
      if (item.idDiaDaSemana === 2 && item.hours.length > 0) {
        setDyasOfTurn((state) => [...state, 'Terça']);
      }
      if (item.idDiaDaSemana === 3 && item.hours.length > 0) {
        setDyasOfTurn((state) => [...state, 'Quarta']);
      }
      if (item.idDiaDaSemana === 4 && item.hours.length > 0) {
        setDyasOfTurn((state) => [...state, 'Quinta']);
      }
      if (item.idDiaDaSemana === 5 && item.hours.length > 0) {
        setDyasOfTurn((state) => [...state, 'Sexta']);
      }
      if (item.idDiaDaSemana === 6 && item.hours.length > 0) {
        setDyasOfTurn((state) => [...state, 'Sábado']);
      }
      if (item.idDiaDaSemana === 0 && item.hours.length > 0) {
        setDyasOfTurn((state) => [...state, 'Domingo']);
      }
    });
  };

  function modeEdit() {
    const {
      nome,
      bairro: bairroApi,
      endereco,
      numeroEndereco,
      complementoEndereco,
      codigoCategoriaLocal,
      codigoClassificacao,
      urlImagem,
      turnos,
      dobraPosicaoPermitida,
      limiteAgendamentosTurnoManha,
      limiteAgendamentosTurnoNoite,
      limiteAgendamentosTurnoTarde,
      limiteAgendamentosTurno,
    } = localData;

    prepareDatas(
      turnos,
      limiteAgendamentosTurnoManha,
      limiteAgendamentosTurnoTarde,
      limiteAgendamentosTurnoNoite,
    );

    setDobraPosicao(dobraPosicaoPermitida);
    setLimiteAgendamentos(limiteAgendamentosTurno);
    setName(nome);
    setBairro(bairroApi);
    setAddres(endereco);
    setNumber(numeroEndereco);
    setComplement(complementoEndereco === null ? null : complementoEndereco);

    setCategorySelectedObj(dataCategoria.filter((item) => item.codigo === codigoCategoriaLocal)[0]);
    setClassificationSelectedObj(dataClassifications.filter((item) => item.codigo === codigoClassificacao)[0]);
    setImgBase64(urlImagem);
  }

  const getData = () => {
    dispatch(requestCategory());
    dispatch(requestLocalClassifictations());
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const filterImg = (img: String) => {
    if (img.includes('jpeg')) {
      return img.replace('data:image/jpeg;base64,', '');
    }
    if (img.includes('png')) {
      return img.replace('data:image/png;base64,', '');
    }
  };

  const saveOrEdit = async () => {
    const turnosStruct: any = CreateFunction(daysOfWeek);
    const payload = {
      codigoCategoriaLocal: categorySelectedObj?.codigo,
      nomeLocal: name,
      endereco: addres || null,
      numeroEndereco: number,
      complementoEndereco: complement || null,
      bairro,
      imagem: imgBase64.includes('https') ? null : {
        nome: imgBase64Name,
        imagemBase64: filterImg(imgBase64),
      },
      limiteAgendamentosTurnoManha: CodePerShift[0].limiteAgendamentosTurnoPorUsuario,
      limiteAgendamentosTurnoTarde: CodePerShift[1].limiteAgendamentosTurnoPorUsuario,
      limiteAgendamentosTurnoNoite: CodePerShift[2].limiteAgendamentosTurnoPorUsuario,
      limiteAgendamentosTurno: Number(LimiteAgendamentosTurnos),
      codigoClassificacaoLocal: classificationSelectedObj?.codigo,
      dobraPosicaoPermitida: dobraPosicao,
      turnos: turnosStruct,
      idsUsuariosVinculadosLocal: users?.filter((item) => item.check).map((item) => item.id),
    };
    if (statesParams?.edit) {
      dispatch(updateLocalAction(payload, statesParams.idLocal));
    } else {
      dispatch(createLocalAction(payload));
    }
  };

  const CleanPositon = (id: number, period: number) => {
    setDaysOfWeek(DaysOfWeek?.map((item) => {
      if (item.idDiaDaSemana === id) {
        item?.hours?.map((it: any) => {
          if (it.id === id && it.idTurno === period) {
            it.quantidadePosicoes = '';
            return it;
          }
          return it;
        });
        return item;
      }
      return item;
    }));
  };

  const CleanAllPositon = () => {
    setDaysOfWeek(DaysOfWeek?.map((item) => {
      item?.hours?.map((it: any) => {
        it.quantidadePosicoes = null;
        return it;
      });
      return item;
    }));
  };

  function handleModal() {
    return (
    // @ts-ignore
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <div style={{ display: 'flex', flex: 1 }}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Fechar
              </Typography>
              <Button autoFocus style={style.textSave} color="inherit" onClick={handleClose}>
                Salvar
              </Button>
            </Toolbar>
          </AppBar>
        </div>
        <List>
          <ContainerRow>
            <PeriodoContainer>
              {turnos?.map((item: Turn) => <CheckBox id={item.idTurno} label={item.label} typeOperation="period" days={turnos} check={item.check} onChange={turnosSelecionados} />)}
            </PeriodoContainer>
            <ContainerTurn>
              <DaysContainer>
                {daysOfWeek?.map((item: DayOffWeek, index: number) => (
                  <div style={{
                    marginLeft: 10, marginRight: 10,
                  }}
                  >
                    <Card style={{ padding: 10 }}>
                      <CheckBox id={item.idDiaDaSemana} label={item.label} typeOperation="day" days={daysOfWeek} check={item.check} onChange={setDaysOfWeek} />
                      <Button
                        style={{
                          marginRight: 60, width: '100%', fontSize: 12, height: 24,
                        }}
                        variant="outlined"
                        size="small"
                        color="secondary"
                        onClick={() => CleanPositon(item.idDiaDaSemana, turnos[0]?.idTurno)}
                      >
                        Limpar posição
                      </Button>
                      <TimePickerComponent
                        id={item.idDiaDaSemana}
                        data={daysOfWeek}
                        onChange={setDaysOfWeek}
                        label="Entrada"
                        period={turnos[0]?.idTurno}
                        periodSelected={turnos[0]?.check}
                      />
                      <TimePickerComponent
                        id={item.idDiaDaSemana}
                        data={daysOfWeek}
                        onChange={setDaysOfWeek}
                        label="Saída"
                        period={turnos[0]?.idTurno}
                        periodSelected={turnos[0]?.check}
                      />
                      <SelectInput
                        id={item.idDiaDaSemana}
                        period={turnos[0]?.idTurno}
                        options={positions}
                        data={daysOfWeek}
                        onChange={setDaysOfWeek}
                        periodSelected={turnos[0]?.check}
                      />
                    </Card>
                    <div style={{ marginTop: 20 }} />
                    <Card style={{ padding: 10 }}>
                      <Button
                        style={{
                          marginRight: 60, width: '100%', fontSize: 12, height: 24,
                        }}
                        variant="outlined"
                        size="small"
                        color="secondary"
                        onClick={() => CleanPositon(item.idDiaDaSemana, turnos[1]?.idTurno)}
                      >
                        Limpar posição
                      </Button>
                      <TimePickerComponent
                        id={item.idDiaDaSemana}
                        data={daysOfWeek}
                        onChange={setDaysOfWeek}
                        label="Entrada"
                        period={turnos[1]?.idTurno}
                        periodSelected={turnos[1]?.check}
                      />
                      <TimePickerComponent
                        id={item.idDiaDaSemana}
                        data={daysOfWeek}
                        onChange={setDaysOfWeek}
                        label="Saída"
                        period={turnos[1]?.idTurno}
                        periodSelected={turnos[1]?.check}
                      />
                      <SelectInput
                        id={item.idDiaDaSemana}
                        period={turnos[1]?.idTurno}
                        options={positions}
                        data={daysOfWeek}
                        onChange={setDaysOfWeek}
                        periodSelected={turnos[1]?.check}
                      />
                    </Card>
                    <div style={{ marginTop: 20 }} />
                    <Card style={{ padding: 10 }}>
                      <Button
                        style={{
                          marginRight: 60, width: '100%', fontSize: 12, height: 24,
                        }}
                        variant="outlined"
                        size="small"
                        color="secondary"
                        onClick={() => CleanPositon(item.idDiaDaSemana, turnos[2]?.idTurno)}
                      >
                        Limpar posição
                      </Button>
                      <TimePickerComponent
                        id={item.idDiaDaSemana}
                        data={daysOfWeek}
                        onChange={setDaysOfWeek}
                        label="Entrada"
                        period={turnos[2]?.idTurno}
                        periodSelected={turnos[2]?.check}
                      />
                      <TimePickerComponent
                        id={item.idDiaDaSemana}
                        data={daysOfWeek}
                        onChange={setDaysOfWeek}
                        label="Saída"
                        period={turnos[2]?.idTurno}
                        periodSelected={turnos[2]?.check}
                      />
                      <SelectInput
                        id={item.idDiaDaSemana}
                        period={turnos[2]?.idTurno}
                        options={positions}
                        data={daysOfWeek}
                        onChange={setDaysOfWeek}
                        periodSelected={turnos[2]?.check}
                      />
                    </Card>
                    <div style={{ marginTop: 30, flexDirection: 'column' }}>
                      {index === 0 ? (
                        <span style={{ fontFamily: 'Graphik-Bold', fontSize: 12, flex: 1 }}>Limite de agendamentos por turno*</span>
                      ) : null}
                      <br />
                      <br />
                      {index === 0 ? (
                        <Card style={{ padding: 10 }}>
                          <SelectInput
                            id={0}
                            label="Manhã"
                            period={turnos[0]?.idTurno}
                            options={quantityPersonToTurn}
                            data={daysOfWeek}
                            onChange={turnosSelecionados}
                            periodSelected={turnos[0]?.check}
                            typeOperation="LIMITE"
                            CodePerShift={turnos}
                          />
                        </Card>
                      ) : null}
                      {index === 1 ? (
                        <Card style={{ padding: 10 }}>
                          <SelectInput
                            id={1}
                            label="Tarde"
                            period={turnos[1]?.idTurno}
                            options={quantityPersonToTurn}
                            data={daysOfWeek}
                            onChange={turnosSelecionados}
                            periodSelected={turnos[1]?.check}
                            typeOperation="LIMITE"
                            CodePerShift={turnos}
                          />
                        </Card>
                      ) : null}
                      {index === 2 ? (
                        <Card style={{ padding: 10 }}>
                          <SelectInput
                            id={2}
                            label="Noite"
                            period={turnos[2]?.idTurno}
                            options={quantityPersonToTurn}
                            data={daysOfWeek}
                            onChange={turnosSelecionados}
                            periodSelected={turnos[2]?.check}
                            typeOperation="LIMITE"
                            CodePerShift={turnos}
                          />
                        </Card>
                      ) : null}
                    </div>
                  </div>
                ))}
              </DaysContainer>
            </ContainerTurn>
          </ContainerRow>
          <FooterTurn>
            <FooterTurnContainerRight>
              <div>
                <Button variant="contained" onClick={() => CleanAllPositon()} disabled={loading} style={style.textButton}>
                  Resetar posições
                </Button>
              </div>
            </FooterTurnContainerRight>
          </FooterTurn>
        </List>
      </Dialog>
    );
  }

  const checkItem = (id: String) => {
    setUsers(
      users?.map((item) => {
        if (id === item.id) {
          item.check = !item.check;
          return item;
        }
        return item;
      }),
    );
  };

  const unCheck = () => {
    setUsers(
      users?.map((item) => {
        item.check = false;
        return item;
      }),
    );
  };

  const getUsersByLocal = () => users?.filter((item) => item.check) || [];

  const onFileChange = (event: any) => {
    if (!event.target.files[0]) {
      return;
    }
    const reader = new FileReader();
    const file = event.target.files[0];

    if ((file?.size / 1024) > 200) {
      setImgError(true);
      return;
    }
    reader.onloadend = () => {
      // @ts-ignore
      setImgBase64(reader.result);
      setImgBase64Name(file.name);
      setImgError(false);
      setTimeSee(true);
      setTimeout(() => {
        setTimeSee(false);
      }, 2000);
    };
    reader.readAsDataURL(file);
  };

  const removeUserFromList = (id: String): void => {
    setUsers(users?.map((item) => {
      if (item.id === id) {
        item.check = !item.check;
        return item;
      }
      return item;
    }));
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setUsers(users?.map((item) => {
        item.check = false;
        return item;
      }));
    } else {
      setUsers(users?.map((item) => {
        item.check = true;
        return item;
      }));
    }
    setSelectAll(!selectAll);
  };

  const handleUsers = () => (
    <LeftContainer>
      <SizedBox />
      <SizedBox />
      <SearchBar value={search} setValue={setSearch} placeholder="Pesquisar corretores" />
      <SizedBox />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <select
          style={{
            margin: 10, padding: 10, borderRadius: 5, width: '50%',
          }}
          onChange={(e) => setFilterActive(e.target.value)}
        >
          <option value="">Todos</option>
          <option value="true">Ativo</option>
          <option value="false">Inativo</option>
        </select>
        <button
          style={{
            margin: 10, padding: 10, borderRadius: 5, width: '50%', backgroundColor: Colors.primary,
          }}
          type="button"
          onClick={toggleSelectAll}
        >
          <p style={{
            textAlign: 'center', color: 'white', fontSize: '12px', fontWeight: 'bold',
          }}
          >
            {selectAll ? 'DESMARCAR TODOS' : 'SELECIONAR TODOS' }
          </p>
        </button>
      </div>
      <ScrowView>
        <List dense style={{ height: '70%' }}>
          {users?.filter((item) => {
            if (search) {
              return (
                (item?.nome || '')
                  .toUpperCase()
                  .indexOf(search.toUpperCase()) !== -1
              );
            }
            return true;
          }).map((item: UserPlatform) => (
            <ItemUser
              nameColor={Colors.grey1}
              key={item.id}
              name={item.nome}
              sigla={item.siglaNome}
              icone={
              item.check ? (
                <MdCheckCircle
                  onClick={() => checkItem(item.id)}
                  color={Colors.check}
                />
              ) : (
                <MdPanoramaFishEye
                  onClick={() => checkItem(item.id)}
                  color={Colors.unCheck}
                />
              )
            }
            />
          ))}
        </List>
      </ScrowView>
      <SizedBox />
      <LeftContainerFooter>
        <UnderlineButton
          isLoading={loading}
          text="Voltar"
          onPress={() => {
            setOpenLocal(false);
          }}
        />
        <Space />
        <UnderlineButton
          isLoading={loading}
          text="Salvar"
          backgroundColor={Colors.grey1}
          textColor={Colors.white}
          onPress={() => {
            setOpenLocal(false);
          }}
        />
      </LeftContainerFooter>
    </LeftContainer>
  );

  return (
    <>
      <NavCommon
        breadcrumbs={[
          { path: '/listar-locais', name: 'Locais' },
          { path: '', name: statesParams.localName || '' },
        ]}
        onBack={() => { history.goBack(); }}
        onChange={() => {

        }}
      />
      <ContainerExt>
        <Container component="main" maxWidth="xl">
          {handleModal()}
          <GlobalModal openeded={openLocal} setOpened={() => setOpenLocal(false)} position="flex-end" widget={handleUsers()} />
          {loadingLocalData ? (
            <MyLoader />
          ) : (
            <>
              <br />
              <GoBack />
              <Divider style={{ marginTop: 20, marginBottom: 10 }} />
              <ContainerTurnRow>
                <ContainerTurnColum>
                  {statesParams?.isPDV && (
                  <PDV>PDV</PDV>
                  )}
                  <PlaceName>{name}</PlaceName>
                </ContainerTurnColum>
                <ContainerBtn>
                  <DayRounded turnsWeek={daysOfTurn} />
                  <ButtonWithIcon
                    text={statesParams?.edit ? 'Editar turnos' : 'Adicionar turnos'}
                    icon={<MdAccessTime size={22} color={Colors.white} />}
                    onPress={() => { handleClickOpen(); }}
                    isLoading
                  />
                </ContainerBtn>
              </ContainerTurnRow>
              <Divider style={{ marginTop: 20, marginBottom: 10 }} />
              <ContainerForm>
                <Cards>
                  {imgBase64 ? (
                    <label htmlFor="file-input">
                      <input
                        type="file"
                        accept="image/*"
                        name="file"
                        id="file-input"
                        className="inputfile"
                        onChange={onFileChange}
                      />
                      {/* @ts-ignore */}
                      <ContainerImageBase style={{ opacity: 10 }} img={imgBase64}>
                        {timeSee && (
                        <>
                          <ImageIconSucess src={CheckSucess} />
                          <SmallPorcent>
                            100 %
                          </SmallPorcent>
                          <DescriptionPhoto style={{ color: Colors.white }}>{imgBase64Name}</DescriptionPhoto>
                        </>
                        )}
                      </ContainerImageBase>
                    </label>
                  ) : (
                    <label htmlFor="file-input">
                      <input
                        type="file"
                        accept="image/*"
                        name="file"
                        id="file-input"
                        className="inputfile"
                        onChange={onFileChange}
                      />
                      {imgErro ? (
                        <ContainerImageVoid id="file">
                          <Rounded color={imgErro ? Colors.warning : Colors.white} id="file">
                            <IoIosWarning size={26} color={Colors.warning} />
                          </Rounded>
                          <TextFile style={{ color: Colors.warning }}>
                            A imagem não pôde ser carregada!
                          </TextFile>
                          <SubTextFile style={{ color: Colors.warning }}>
                            Imagem selecionada é muito grande selecione outra imagem!
                          </SubTextFile>
                        </ContainerImageVoid>
                      ) : (
                        <ContainerImageVoid id="file">
                          <Rounded id="file" color={Colors.white}>
                            <ImageIcon src={UploadFile} />
                          </Rounded>
                          <TextFile>
                            Solte a imagem aqui ou clique para subir.
                          </TextFile>
                          <SubTextFile>
                            Arquivos em JPG ou PNG com até 200 mb.
                          </SubTextFile>
                        </ContainerImageVoid>
                      )}
                    </label>
                  )}
                  <Form>
                    <RowForm>
                      <ColumnForm>
                        <Padding>
                          <Input required value={name || ''} onChange={setName} type="text" label="Nome" />
                        </Padding>
                        <RowInput>
                          <Padding>
                            <Input required value={addres || ''} onChange={setAddres} type="text" label="Endereço" />
                          </Padding>
                          <Input value={number || ''} onChange={setNumber} type="number" label="Número" />
                        </RowInput>
                        <RowInput>
                          <Padding>
                            <Input required value={bairro || ''} onChange={setBairro} type="text" label="Bairro" />
                          </Padding>
                          <Input value={complement || ''} onChange={setComplement} type="text" label="Complemento" />
                        </RowInput>
                        <RowSelect>
                          <Padding>
                            <SelectCustom
                              required
                              values={categorySelectedObj?.codigo || ''}
                              onchangeObject={setCategorySelectedObj}
                              data={dataCategoria}
                              label="Categoria"
                            />
                          </Padding>
                          <SelectCustom
                            values={classificationSelectedObj?.codigo || ''}
                            onchangeObject={setClassificationSelectedObj}
                            data={dataClassifications}
                            label="Classificação"
                          />
                        </RowSelect>
                        <SizedBox />
                        <SizedBox />
                        <Divider />
                        <SizedBox />
                        <SizedBox />
                        <RowInput>
                          <SmallForm>Habilitar dobra de posição</SmallForm>
                          <IOSSwitch check={dobraPosicao || false} onClick={() => setDobraPosicao(!dobraPosicao)} />
                        </RowInput>
                        <SizedBox />
                        <Divider />
                        <SizedBox />
                        <SizedBox />
                        <RowInput>
                          <SmallForm>Limite de posições por corretor</SmallForm>
                          <RowBtn>
                            <ButtonIconRounde
                              icon={<HiOutlinePlusSm style={{ color: Colors.white }} />}
                              onPress={() => {
                                const value = LimiteAgendamentosTurnos + 1;
                                setLimiteAgendamentos(value);
                              }}
                            />
                            <SmallForm
                              style={{
                                marginLeft: 8,
                                marginRight: 8,
                              }}
                            >
                              {LimiteAgendamentosTurnos}
                            </SmallForm>
                            <ButtonIconRounde
                              icon={<HiMinusSm style={{ color: Colors.white }} />}
                              onPress={() => {
                                const value = LimiteAgendamentosTurnos - 1;
                                setLimiteAgendamentos(value <= 0 ? 0 : value);
                              }}
                            />
                          </RowBtn>
                        </RowInput>
                      </ColumnForm>
                    </RowForm>
                    <SizedBox />
                    <SizedBox />
                    <Footer>
                      <UnderlineButton
                        isLoading={loading}
                        text={statesParams?.edit ? 'Salvar alterações' : 'Salvar'}
                        backgroundColor={Colors.grey1}
                        textColor={Colors.white}
                        onPress={() => {
                          saveOrEdit();
                        }}
                      />
                      <SizedBox />
                    </Footer>
                  </Form>
                </Cards>
                <ContainerColumnUsers>
                  <ContainerRownHeader>
                    <SubContainerHedaer>
                      <Small>
                        {users?.filter((item) => item.check).length}
                        {' '}
                        corretores no local
                      </Small>
                      <ButtonIconRounde
                        icon={<IoMdPersonAdd style={{ color: Colors.white }} />}
                        onPress={() => {
                          setOpenLocal(true);
                        }}
                      />
                    </SubContainerHedaer>
                  </ContainerRownHeader>
                  <Divider style={{ margin: 20 }} />
                  <ContainerColumnList>
                    {getUsersByLocal().filter((_, index) => index < sizeList).map((item) => (
                      <ItemUser
                        key={item.id}
                        name={item.nome}
                        sigla={item.siglaNome}
                        nameColor="#333"
                        icone={(
                          <FaUserMinus
                            fontSize="large"
                            onClick={() => removeUserFromList(item.id)}
                            style={{ color: Colors.grey1 }}
                          />
                  )}
                      />
                    ))}
                    <SizedBox />
                    <UnderlineButton
                      text="Mostrar mais corretores"
                      onPress={() => {
                        setOpenLocal(true);
                      }}
                    />
                    <SizedBox />
                  </ContainerColumnList>
                </ContainerColumnUsers>
              </ContainerForm>
            </>
          )}
        </Container>
      </ContainerExt>
    </>
  );
};

export default Places;
